module.exports = __webpack_public_path__ + "static/media/dark.230ca0e8.png";